import React from 'react';

const Mentor: React.FC = () => {
  const mentorshipRoles = [
    {
      title: 'Liberating Structures',
      description: 'A few hours long (the duration depends on the group size and your will!) workshop on Liberating Structures.',
      type: 'Leadership'
    },
    {
      title: 'DevOps Academy at EPAM',
      description: 'Led comprehensive DevOps training program, covering Agile, Linux, Docker, Ansible, CI/CD, cloud technologies, and infrastructure automation.',
      type: 'Technical'
    },
    {
      title: 'NTHK Program',
      description: 'Active participant in mentoring program, explaining intersection between DevOps and Security.',
      type: 'Technical'
    },
    {
      title: 'Tech Leaders',
      description: 'Mentorship program for women who want to change their occupation or grow in their IT work.',
      type: 'Technical/Leadership'
    },
    {
      title: 'Grow2Lead Program',
      description: 'EPAM\'s program for aspiting leaders, where we shaped future team leads..',
      type: 'Leadership'
    }
  ];

  const trainings = [
    {
      title: 'Linux Bootcamp',
      description: 'Training for beginners on Linux basics and shell scripting.',
      duration: '4 weeks'
    },
    {
      title: 'Introduction to public speaking',
      description: 'If you do not know where to start, this training is for you.',
      duration: '4-6 hours'
    },
    {
      title: 'Meet the AWS',
      description: 'Introduction to AWS cloud and most common services.',
      duration: '2 days'
    },
    {
      title: 'Good start with CloudFormation',
      description: 'From zero to hero with CloudFormation.',
      duration: '2 days'
    },
    {
      title: 'What DevOps means for Talent Aquisition',
      description: 'In this short training I explain what Devops is and how to recruit good people.',
      duration: '2 hours'
    }
  ];

  return (
    <div className="page mentor">
      <div className="container">
        <section className="hero-section">
          <img 
            src="/images/20240520_095941.jpg" 
            alt="Pawel Piwosz Mentoring" 
            className="mentor-hero-image" 
          />
          <h1>Mentorship & Training</h1>
        </section>
        
        <section className="mentorship-section">
          <h2>Mentorship Roles</h2>
          <div className="mentorship-grid">
            {mentorshipRoles.map((role) => (
              <div key={role.title} className="mentor-card">
                <h3>{role.title}</h3>
                <span className="role-type">{role.type}</span>
                <p>{role.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="training-section">
          <h2>Training Portfolio</h2>
          <div className="training-grid">
            {trainings.map((training) => (
              <div key={training.title} className="training-card">
                <h3>{training.title}</h3>
                <span className="duration">{training.duration}</span>
                <p>{training.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Mentor;